export const PLACES_APP_NAME = "Microsoft Places";
export const PLACES_BRANDING_NAME = "Places";
export const CHANGE_ORGANIZER_MODULE_NAME = "Respond to Change Organizer";
